import React, { useEffect, useState } from 'react'
import { Box, display } from '@mui/system'
import { Drawer, Grid, IconButton, Paper, Stack, TextField, Typography } from '@mui/material'
import { useDispatch } from 'react-redux'
import CandidateSideBar from './Profile/CandidateSideBar'
import Navbar from '../Navbar'
import companyLogo from '../../images/companyLogo.jpg'
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import AppliedJobsTable from './AppliedJobsTable';
import Layout from '../../assets/Layout';
import UserLayout from '../../assets/UserLayout';
import { getAppliedJobs, getUserInformation } from '../../actions/userAuth';
import { useParams } from 'react-router-dom';

export default function AppliedJobs() {
    const [user, setUser] = useState("");
    const dispatch = useDispatch();
    const [isDrawerOpen, setIsDrawerOpen] = useState(true);
    const [checked, setChecked] = useState(false);
    const [selectedOption, setSelectedOption] = useState('');
    const { id } = useParams();


    const handleChange = () => {
        setSelectedOption(!checked);
    };
    const handleDrawerToggle = () => {
        setIsDrawerOpen(!isDrawerOpen);
    };

    useEffect(() => {
        if (localStorage.getItem("refreshToken")) {
            dispatch(getUserInformation({}, (data) => {
                dispatch({
                    type: "LOG_IN",
                    payload: data.data.data,
                });
                localStorage.setItem("user", JSON.stringify(data.data.data));
                setUser(data.data.data);
            }, (err) => {
                console.log(err);
            }, localStorage.getItem("refreshToken")
            ))
        }
    }, []);

    // useEffect(() => {
        
    //     if (localStorage.getItem("refreshToken")) {
    //         dispatch(getAppliedJobs({id}, (data) => {
    //             dispatch({
    //                 type: "LOG_IN",
    //                 payload: data.data.data,
    //             });
    //             localStorage.setItem("user", JSON.stringify(data.data.data));
    //             setUser(data.data.data);
    //         }, (err) => {
    //             console.log(err);
    //         }, localStorage.getItem("refreshToken")
    //         ))
    //     }
    // }, [dispatch, id]);

    const handleSearch = (event) => {
        const searchTerm = event.target.value;
    };

    return (
        <>
            <Layout>
                <UserLayout>
                    <Box sx={{ display: 'flex', flexDirection: 'row', my: 8, borderRadius: '10px' }}>
                        <Typography variant="h6" sx={{ fontWeight: 'bold', width: '100%' }}>Applied Jobs</Typography>
                        <Grid item md={2} sx={{ display: 'flex', verticalAlign: 'middle', alignItems: 'center', height: '2.5rem' }}>
                            <select
                                style={{ marginLeft: '1rem', backgroundColor: '#D9E3F6' }}
                                className='profile-skills-box text2Light'
                                value={selectedOption}
                                onChange={handleChange}
                            >
                                <option disabled value="">
                                    Sort by date
                                </option>
                                <option value="option1">Option 1</option>
                                <option value="option2">Option 2</option>
                                <option value="option3">Option 3</option>
                            </select>
                        </Grid>
                    </Box>
                    <Grid item md={12}>
                        <AppliedJobsTable id={id} />
                    </Grid>
                </UserLayout>
            </Layout>
        </>
    )
}
